/**
 * @desc 导出
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(params: API.fulfilment.warehouseCost.exporting.Params, options?: any) {
  return updateResponse(
    http(URL + `/warehouseCost/export`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
